import { render, staticRenderFns } from "./My-events.vue?vue&type=template&id=39e54a94&"
import script from "./My-events.vue?vue&type=script&lang=js&"
export * from "./My-events.vue?vue&type=script&lang=js&"
import style0 from "./My-events.vue?vue&type=style&index=0&scope=true&lang=css&"
import style1 from "./My-events.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports